export default __webpack_public_path__ + "static/multisensor-e36e434c88e0a588869b58c2c0fac852.png";